/* eslint-disable @typescript-eslint/camelcase */
import { post } from '@/utils/network';

export interface ProductItem {
  createtime?: string;
  deltime?: string;
  desc?: string; // product descriptions
  discount?: string; // 折扣
  id?: string;
  months?: string; // 有效单位（月）
  orgin_price?: string; // 原价
  price?: number; // 真实价格(单位分)
  product_type?: '1' | '2'; // product_type 1 : normal vip 2: super vip.
  productname?: string;
  self_vip_discount?: number;
  sort?: '9'; // 排序值
  state?: '0'; // 产品状态【1：下架，0：正常
  type?: '1'; // 产品的类型【0：学生 1：老师】
  updatetime?: null;
  viptype?: '0'; // 产品的额外的标识的类型,以便支撑其他活动
}
export const getProductsList = (
  params: {
    viptype: string;
    product_type: 1 | 2;
  } // product_type 1 : normal vip 2: super vip.
) => post<Array<ProductItem>>('/VipApi/getProductLists', params);
// 获取支付链接
export const getWeChatPayJSAPI = (params: { openid: string; productid: string, checkRepeateOrderNo?:string}) =>
  post<{
    orderNo: string;
    pay: {
      appId: string; // 公众号名称，由商户传入
      timeStamp: string; // 时间戳，自1970年以来的秒数
      nonceStr: string; // 随机串
      package: string;
      signType: string; // 微信签名方式：
      paySign: string; // 微信签名
    }; // 下单链接
  }>('/PayApi/getWeChatPayJSAPI', params);
// 获取支付状态
export const getPaytate = (params: { orderno: string }) =>
  post<{
    state: string; // 0未支付 1已支付 2已退款
  }>('/VipApi/getUserOrderPayState', params);

export default { getProductsList, getWeChatPayJSAPI, getPaytate };
